<div class="container">
    <ng-container> <!-- to do ngfor  -->
        <app-accordion-items></app-accordion-items>
    </ng-container>
</div>